export let routes = [
    {
      path: '/x3-side-class',
      name: 'x3-side-class',
      component: () => import('@x3/js/side/class/class.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
    {
      path: '/x3-side-class-filtrate',
      name: 'x3-side-class-filtrate',
      component: () => import('@x3/js/side/class/filtrate/filtrate.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
  ];
  
  export let api = {
    xsClass(options) {
      return new Promise((resolve, reject) => {
        app.router.push(
          '/x3-side-class',
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.options = options;
          },
          err => {
            console.log(err);
          }
        );
      });
    },
    xsClassFiltrate(options) {
      return new Promise((resolve, reject) => {
        app.router.push(
          '/x3-side-class-filtrate',
          route => {
            route.meta._resolve = resolve;
            route.meta._reject = reject;
            route.meta.options = options;
          },
          err => {
            console.log(err);
          }
        );
      });
    },
  };
  